const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_BASE_URL ||
  "https://distinguished-robby-aagati-15819a4f.koyeb.app/api/v1";

/**
 * Returns the Authorization header using the stored access token.
 */
function getAuthHeaders() {
  const token = localStorage.getItem("tokens");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

/**
 * Generic API request helper. Throws an Error if the response is not ok.
 * @param {string} path - URL path (relative to BASE_URL)
 * @param {RequestInit} [options] - Fetch options
 * @returns {Promise<any>} - Parsed JSON response data
 */
export async function apiRequest(path, options = {}) {
  const url = path.startsWith("http") ? path : `${BASE_URL}${path}`;
  const response = await fetch(url, {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...(options.headers || {}),
    },
  });

  const json = await response.json();

  if (!response.ok) {
    throw new Error(json.message || `Request failed: ${response.status}`);
  }

  return json;
}

export { BASE_URL };
